<!-- 批准/否决 审批弹窗 -->
<template>
  <div>
    <!-- 弹窗-添加/修改 -->
    <simple-modal 
      ref    ="refuse"
      :title ="$I18n('reje_appl')"
      :right ="false"
      :submitBtnName="$I18n('certainty')"
      @submit="submit"
    >
      <template slot="body">
        <div>
          <common-form-item 
            :labelweight="165"
            v-for="item in formItem" 
            v-model="formData.Form[item.keys]" 
            :error="formData.Error[item.keys]" 
            :key="item.keys" v-bind="item"
          >
          </common-form-item >
        </div>
      </template>
    </simple-modal>
    <!--  -->
    <!-- <simple-modal 
      ref    ="agree"
      :title ="$I18n('present')"
      :right ="false"
      :submitBtnName="$I18n('certainty')"
      @submit="submit"
    >
      <template slot="body">
        <div style="padding-left: 15px;">{{$I18n('confir_apply')}}</div>
      </template>
    </simple-modal> -->
  </div>
</template>
<script>
import { FormClass } from "@/common/tools.js";
export default {
  name: "modal-appr",
  // props:["organi"],
  data() {
    return{
      showEmail: false,
      // title:"",
      type :"add",
      formData: new FormClass({ // 弹窗-表单数据
        reason: "",
      }),
      depts: [],
    }
  },
  mounted(){ },
  computed: {
    formItem(){
      return[
        {
          label  : this.$I18n("pls_fill_reason"),
          keys     : "reason",
          type     : "input",
          check    : true,
          placeholder: this.$I18n("appr_comm"),
        },
      ]
    },
  },
  methods:{
    /*
      type : refuse | agree
      data : 表单基础数据
    */
    open(type, data){
      this.type = type;
      this.depts = this.UserInfo.depts;
      if(type === "refuse"){
        this.$refs.refuse.open();
        this.formData.Update(data);
      } else if(type === "agree"){
        this.formData.Update(data);
        this.$confirm(this.$I18n("confir_apply"), this.$I18n("present"), {
          confirmButtonText: this.$I18n("certainty"),
          cancelButtonText : this.$I18n("cancle"),
          type: 'info'
        }).then(() => {
          this.submit();
        }).catch(() => { })
      }
    },
    submit(){
      if(this.type === "refuse"){
        this.refuse();
      } else if(this.type === "agree"){
        this.agree();
      }
    },
    // 调用父组件传递的close方法 制造提交成功后执行
    close(){
      this.$refs.refuse.close();
      if(this.$listeners["close"]){
       this.$emit('close');
      }
    },
    refuse(){
      this.$api.s_Appr({
        ...this.formData.Form,
        state: 3,
      })
        .then(this.$Then(() => {
          this.$successMsg(this.$I18n("success"));
          this.close();
        }))
        .catch(this.$Catch(this.$I18n("error")))
    },
    agree(){
      this.$api.s_Appr({
        ...this.formData.Form,
        state: 2,
      })
        .then(this.$Then(() => {
          this.$successMsg(this.$I18n("success"));
          this.close();
        }))
        .catch(this.$Catch(this.$I18n("error")))
    },
  },
}
</script>

<style scoped></style>